/* eslint-disable import/no-anonymous-default-export */
import { SET_LOCK_WINDOW } from '../actionConstants';

export default (state = true, action) => {
  switch (action.type) {
    case SET_LOCK_WINDOW:
      return action.payload;
    default:
      return state;
  }
};
